import React from 'react';
import { PlanVehicleRulePanel } from './PlanVehicleRulePanel';

interface Props {
    systemPlanId?: string | null;
}

export const SmriqVehicleEligibilityPanel: React.FC<Props> = ({ systemPlanId }) => {
    if (!systemPlanId) {
        return (
            <p className="text-mp-muted text-sm">
                Vehicle eligibility becomes available once the product is saved as an SMRiQ product.
            </p>
        );
    }

    return (
        <div className="space-y-4">
            <p className="text-sm text-mp-muted">
                Add a vehicle rule so this product appears for matching vehicles.
            </p>
            <PlanVehicleRulePanel planId={systemPlanId} />
        </div>
    );
};
